import styled from "styled-components";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";

export {
  Backdrop,
  Pane,
  PaneHeader,
  PaneTitle,
  CloseBtn,
  PaneDescription,
  PaneFooter,
} from "./analytics.pane.styles";

export {
  EmptyNote,
  DeleteBtn,
  AddSection,
  AddSectionTitle,
  FormField,
  FormLabel,
  FormInput,
  FormRow,
  DatePickerWrapper,
  AddButtonRow,
} from "./analytics.form.styles";

export const CostList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 24px;
  overflow-y: auto;
  flex: 1;
  min-height: 80px;
`;

export const CostRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border: 1.5px solid ${ColorV2.Blue6};
  border-radius: 10px;
  background: ${ColorV2.White};
`;

export const CostInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const CostTitle = styled.span`
  ${TypographyV2.s1}
  color: ${ColorV2.Blue1};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CostMeta = styled.span`
  ${TypographyV2.s1}
  color: ${ColorV2.Blue4};
`;

export const KindToggleRow = styled.div`
  display: flex;
  border: 1.5px solid ${ColorV2.Blue5};
  border-radius: 10px;
  overflow: hidden;
`;

export const KindBtn = styled.button<{ $active: boolean }>`
  ${TypographyV2.s1}
  flex: 1;
  padding: 7px 12px;
  border: none;
  cursor: pointer;
  background: ${({ $active }) =>
    $active ? ColorV2.ElectricBlue : ColorV2.White};
  color: ${({ $active }) => ($active ? ColorV2.White : ColorV2.Blue3)};
  transition:
    background 0.15s,
    color 0.15s;

  &:not(:last-child) {
    border-right: 1.5px solid ${ColorV2.Blue5};
  }

  &:hover {
    background: ${({ $active }) =>
      $active ? ColorV2.ElectricBlue : ColorV2.Blue6};
  }
`;

export const PeriodSelect = styled.select`
  ${TypographyV2.b2}
  color: ${ColorV2.Blue1};
  background: ${ColorV2.White};
  border: 1.5px solid ${ColorV2.Blue5};
  border-radius: 10px;
  padding: 8px 12px;
  appearance: none;
  cursor: pointer;
  width: 100%;
  outline: none;

  &:focus {
    border-color: ${ColorV2.ElectricBlue};
  }

  &:hover {
    border-color: ${ColorV2.Blue4};
  }
`;
